(function () {
  function getParts(root) {
    return {
      toggle: root.querySelector('[data-terjung-preorder-toggle]'),
      fields: root.querySelector('[data-terjung-preorder-fields]'),
      select: root.querySelector('[data-terjung-preorder-window]'),
      error: root.querySelector('[data-terjung-preorder-error]'),
      form: root.closest('form') || document.getElementById(root.querySelector('[form]')?.getAttribute('form')),
    };
  }

  function sync(root) {
    const parts = getParts(root);
    if (!parts.toggle || !parts.fields || !parts.select) return;
    const isChecked = parts.toggle.checked;
    parts.fields.hidden = !isChecked;
    parts.select.disabled = !isChecked;
    parts.select.required = isChecked;
    if (!isChecked) {
      parts.select.value = '';
      if (parts.error) parts.error.hidden = true;
    }
    if (parts.form) {
      parts.form.querySelectorAll('.shopify-payment-button').forEach((button) => {
        button.hidden = isChecked;
      });
    }
  }

  function showError(root) {
    const parts = getParts(root);
    if (parts.error) parts.error.hidden = false;
    if (parts.select) parts.select.focus();
    window.setTimeout(() => {
      document.querySelectorAll('.working').forEach((element) => element.classList.remove('working'));
    }, 0);
  }

  function init() {
    document.querySelectorAll('[data-terjung-preorder-pickup]').forEach(sync);
  }

  document.addEventListener('change', (event) => {
    const root = event.target.closest?.('[data-terjung-preorder-pickup]');
    if (!root) return;
    sync(root);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const root = form.querySelector('[data-terjung-preorder-pickup]');
    if (!root) return;
    const parts = getParts(root);
    if (parts.toggle?.checked && !parts.select?.value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(root);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
